module.exports = " <i class=\"fa fa-4x {{class}}\" ></i>\n\n"